var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyefill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0579 6.23859L21.0579 6.23858C19.6937 4.46222 16.459 0.25 11 0.25C5.541 0.25 2.30625 4.46221 0.942105 6.23858L0.942085 6.2386C0.806903 6.41463 0.690091 6.56674 0.591305 6.68846C0.5 6.79231 0.5 6.89615 0.5 7C0.5 7.10385 0.5 7.20769 0.591305 7.31154C0.690096 7.43326 0.806915 7.58538 0.942105 7.76142C2.30625 9.53779 5.541 13.75 11 13.75C16.459 13.75 19.6937 9.53778 21.0579 7.76142L21.0579 7.76141C21.1931 7.58537 21.3099 7.43326 21.4087 7.31154C21.5 7.20769 21.5 7.10385 21.5 7C21.5 6.89615 21.5 6.79231 21.4087 6.68846C21.3099 6.56674 21.1931 6.41463 21.0579 6.23859ZM11 10.75C13.0711 10.75 14.75 9.07107 14.75 7C14.75 4.92893 13.0711 3.25 11 3.25C8.92893 3.25 7.25 4.92893 7.25 7C7.25 9.07107 8.92893 10.75 11 10.75ZM11 12.25C13.8995 12.25 16.25 9.8995 16.25 7C16.25 4.10051 13.8995 1.75 11 1.75C8.1005 1.75 5.75 4.10051 5.75 7C5.75 9.8995 8.1005 12.25 11 12.25ZM12.5 7C12.9142 7 13.25 6.66421 13.25 6.25C13.25 5.83579 12.9142 5.5 12.5 5.5C12.0858 5.5 11.75 5.83579 11.75 6.25C11.75 6.66421 12.0858 7 12.5 7Z",
    fill: "#283897"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyefill);
export default __webpack_public_path__ + "static/media/Eyefill.558e3362.svg";
export { ForwardRef as ReactComponent };